<hypecast-header></hypecast-header>

<div class="sticky-audio-player" [hidden]="isPipActive()">
  <hypecast-audio-player-control></hypecast-audio-player-control>
</div>

<div class="main-content" [class.audio-player-control--visible]="isControlsVisible()">
  <router-outlet></router-outlet>
</div>
